$(function(){
	var common=require("./common.js");
	var PageController=require("./PageController.js");
	var login = require('./login.js');
	var search=require("./search.js");
	login.init();
	// common.init();
	var index={
		listEl:$(".m-list"),
		navEl:$(".m-nav"),
		school:common.getQueryString("school"),
		limit:8,
		sortby:1,
		pageController:null,
		init:function(){
			var _this=this;
			if(this.school==null&&window.location.href.indexOf("index")!=-1){
				this.navEl.find("li").eq(0).addClass("active");
				this.school=-1;
			}else{
				this.navEl.find("li[data-school="+this.school+"]").addClass("active");
			}
			
			this.listEl.find(".sortByBtn").click(function(){
				var index=$(this).index();
				_this.listEl.find(".sortByBtn").removeClass("active");
				_this.listEl.find(".sortByI").removeClass("i1 i2");
				_this.listEl.find(".sortByI").addClass("i"+(index+1));
				$(this).addClass("active");
				if(index==0){
					_this.sortby=1;
				}else{
					_this.sortby=2;
				}
				_this.initPage();
			})
			this.initPage();

		},
		initPage:function(){
			var _this=this;
			if(this.pageController!=null){
				this.pageController.destroy();
			}
			this.pageController=new PageController($(".pageController"),skillMacrosListCount,this.limit,function(limit,offset){
				$.getJSON("/skillmacros/getSkillmacrosListBySort.json?&limit="+limit+"&offset="+offset+"&sortby="+_this.sortby+"&school="+_this.school,function(msg){
					if(msg.resCode==11){
						console.log("用户未登录");
						return;
					}
					var source   = $("#item-template").html();
					var template = Handlebars.compile(source);
					var context = msg.data;
					var html    = template({list:msg.data});
					$(".m-list ul").html(html);
				})
			})
		}
	}
	index.init();
})


//////////////////
// WEBPACK FOOTER
// ./pages/skillmacros/js/index.js
// module id = 0
// module chunks = 6